import React, {useState} from "react";
import {MenuItem} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {History, ContentPasteSearch} from "@mui/icons-material";
import {useNavigate} from "react-router";
import Record from "../../layouts/record";

interface Props {
    visible: boolean,
    setIsNavOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export function MenusHeader({visible, setIsNavOpen}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };
    const history = useNavigate();
    const [openRecord, setOpenRecord] = useState(false)

    // TODO FUNCIONALIDADES SCORING, MÓDULO PERFIL
    const navListItems = [
        {
            label: "record",
            icon: History,
            action: () => {
                setOpenRecord(prev => !prev)
            },
        },
        // {
        //     label: "account",
        //     icon: Badge,
        //     path: "/account"
        // },
        {
            label: "consult",
            icon: ContentPasteSearch,
            path: "/search"
        },
        // {
        //     label: "score",
        //     icon: Dvr,
        //     menus: [
        //         {
        //             label: "models",
        //             icon: CreditScore,
        //             path: "/config-score",
        //         },
        //         {
        //             label: "ingestion",
        //             icon: DisplaySettings,
        //             path: "/ingestion",
        //         },
        //         {
        //             label: "results",
        //             icon: Dvr,
        //             path: "/trays",
        //         },
        //     ]
        // },
    ];

    // function getMenuList(label: string, icon: any, menus: any[], index: number) {
    //     return (
    //         <Menu key={index}>
    //             <MenuHandler>
    //                 <MenuItem
    //                     key={index}
    //                     placeholder={'menu'}
    //                     className="flex items-center gap-2 w-auto text-[13px]">
    //                     {`${t(label)}`}{React.createElement(icon, {className: "max-w-4"})}
    //                 </MenuItem>
    //             </MenuHandler>
    //             <MenuList placeholder={`menu-${label}`}>
    //                 {menus && menus.map((menu, indexItem) =>
    //                     <MenuItem
    //                         className={'flex flex-row items-center'}
    //                         key={`${indexItem}-menu`}
    //                         placeholder={`menu-item-${indexItem}`}
    //                         onClick={() => {
    //                             if (menu.path) {
    //                                 history(`${menu.path}`)
    //                             }
    //                         }}
    //                     >{`${t(menu.label)}`}
    //                         {React.createElement(menu.icon, {className: "max-w-4 ml-auto"})}
    //                     </MenuItem>)
    //                 }
    //             </MenuList>
    //         </Menu>
    //     )
    // }

    function getMenuItem(
        label: string,
        icon: any,
        path: string | undefined,
        action: (() => void) | undefined,
        index: number) {
        return (
            <MenuItem
                key={index}
                placeholder={'menu'}
                className="flex items-center gap-2 w-auto text-[13px]"
                onClick={action ?
                    () => {
                        action()
                        if (setIsNavOpen) setIsNavOpen(false)
                    } :
                    () => {
                        if (path) {
                            history(`${path}`)
                        }
                        if (setIsNavOpen) setIsNavOpen(false)
                    }}
            >
                {`${t(label)} `}
                {React.createElement(icon, {className: "max-w-4"})}
            </MenuItem>
        )
    }

    return (
        <div className={`${!visible ? 'hidden sm:block' : ''} bg-headerMenus min-h-[54px] sm:max-h-[54px] p-[6px]`}>
            {openRecord && <Record open={openRecord} setOpen={setOpenRecord}/>}
            <ul className="flex flex-col sm:flex-row gap-2">
                {navListItems.map(({
                                       label,
                                       icon,
                                       path,
                                       action,
                                       // menus
                                   }, index) => {
                    // if (menus) {
                    //     return getMenuList(label, icon, menus, index)
                    // }
                    return getMenuItem(label, icon, path, action, index)
                })}
            </ul>
        </div>
    )
}
